<template>
	<div>
		<!-- <Transition name="fade"> -->
			<div v-if="show">
				<div class="tw-modal-container opacity-100 z-50" :class="[showClass, {'nopadding': !padding, 'has-footer': showFooter && (showOk || showCancel)}]">
				  <!--
				    Background overlay, show/hide based on modal state.

				    Entering: "ease-out duration-300"
				      From: "opacity-0"
				      To: "opacity-100"
				    Leaving: "ease-in duration-200"
				      From: "opacity-100"
				      To: "opacity-0"
				  -->


				  <div class="fixed inset-0 transition-opacity">
				    <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
				  </div>

				  <!--
				    Modal panel, show/hide based on modal state. 

				    Entering: "ease-out duration-300"
				      From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
				      To: "opacity-100 translate-y-0 sm:scale-100"
				    Leaving: "ease-in duration-200"
				      From: "opacity-100 translate-y-0 sm:scale-100"
				      To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
				  -->
				  <div class="modal" :class="modalSize" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
					<header class="modal-header" v-if="hasHeader">
						<div class="modal-header-title">
							<h2>
								<slot name="header"></slot>
							</h2>
						</div>
						<div v-if="hasSubtext">
							<p class="modal-header-subtext">
								<slot name="subtext"></slot>
							</p>
						</div>
					</header>
				  	<div class="modal-body">
					  	<div class="block absolute top-0 right-0 pt-4 pr-4" v-if="canClose">
					      <button type="button" class="text-white hover:text-gray-300 focus:outline-none focus:text-gray-300 transition ease-in-out duration-150" aria-label="Close" @click="close">
					        <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
					          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
					        </svg>
					      </button>
					    </div>

					    <div>
					      <div class="mt-3 text-center sm:mt-5" v-if="hasDescription">
					        <div class="mt-2">
					          <p class="text-sm leading-5 text-gray-500">
					            <slot name="description"></slot>
					          </p>
					        </div>
					      </div>
					      <div>
					      	<div class="flex">
							  <!-- <div class="padding-container"></div> -->
							  <div class="flex-1 mx-auto modal-body-scroll">
					      	  	<slot name="body"></slot>
							  </div>
							  <!-- <div class="padding-container"></div> -->
							</div>
					      </div>
					    </div>
				    </div>
				    <div class="modal-footer" v-if="showFooter && (showOk || showCancel)">
				    	<div class="modal-footer-container" :class="{'two-buttons': showOk && showCancel}">
				    		<div v-if="showCancel">
								<tw-button @clicked="handleCancel" variant="secondary" full>{{ cancelText }}</tw-button>
							</div>
				  			<div v-if="showOk">
				  				<tw-button :disabled='okDisabled || okBusy' @clicked="okClicked" full>
				  					<i class="fas fa-circle-notch fa-spin mx-2" v-if='okBusy'></i>
				  					{{ okText }}
				  				</tw-button>
				  			</div>
				  		</div>
				    </div>
				  </div>
				</div>
			</div>
		<!-- </Transition> -->
	</div>
</template>


<script>
	export default {
		name: 'modal',
		props: {
			title: {
				type: String
			},
			canClose: {
				type: Boolean,
				default: true,
			},
			size: {
				type: String, 
			},
			padding: {
				type: Boolean,
				default: true,
			},
			showOk: {
				type: Boolean,
				default: true
			},
			okText: {
				type: String,
				default: 'update',
			},
			cancelText: {
				type: String,
				default: 'cancel',
			},
			showFooter: {
				type: Boolean,
				default: true
			},
			okDisabled: {
				type: Boolean,
				default: false
			},
			okBusy:{
				type:Boolean,
				default:false
			},
			showCancel: {
				type: Boolean,
				default: true
			},
			manualClose: {
				type: Boolean,
				default: false,
			}
		},
		data() {
			return {
				show: false,
				showClass: [],
				modalSize: 'md',
			}
		},
		computed: {
			hasDescription() {
				return !!this.$slots['description']
			},
			hasHeader () {
      			return !!this.$slots['header']
    		},
    		hasSubtext () {
      			return !!this.$slots['subtext']
    		},
		},
		watch: {
			show: function (newVal, oldVal) {
				// when modal should be shown
				if(newVal) {
					this.showClass = ['opacity-100'];
				} else {
					this.showClass = ['opacity-0'];
				}
			}
		},
		mounted() {
			if(this.size) {
				this.modalSize = this.size;
			}
		},
		methods: {
			open(){
				this.show = true;
			},
			close() {
				this.show = false;
				document.body.style.overflowY = 'initial';
			},
			handleCancel(e){
				this.$emit('cancel', e);
				this.close(e);
			},
			okClicked() {
				if(!this.manualClose) {
					this.close();
				}

				this.$emit('ok', true);
			},
			setSize(newSize) {
				this.modalSize = newSize; 
			}
		}
	}
</script>